import Axios from "axios";
import {
  SET_BONUS_PAYMENT_REGISTER_REPORT_LIST,
  UNSET_BONUS_PAYMENT_REGISTER_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusPaymentRegisterReport,
} from "@/store/api";

const state = {
  getBonusPaymentRegisterReport: [],
};

const getters = {
  getBonusPaymentRegisterReport(state) {
    return state.getBonusPaymentRegisterReport;
  },
};

const mutations = {
  [SET_BONUS_PAYMENT_REGISTER_REPORT_LIST](state, data) {
    state.getBonusPaymentRegisterReport = data;
  },
  [UNSET_BONUS_PAYMENT_REGISTER_REPORT_LIST](state) {
    state.getBonusPaymentRegisterReport = [];
  },
};

const actions = {
  getBonusPaymentRegisterReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusPaymentRegisterReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_PAYMENT_REGISTER_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_PAYMENT_REGISTER_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

